<template>
    <div>
        <p class="text-body-2 mb-1">
            {{ $t('user_settings.change_language.language_field') }}
        </p>
        <v-select
            v-model="selectedLanguage"
            :items="languages"
            item-title="label"
            item-value="value"
            hide-details
            variant="outlined"
            density="compact"
            :menu-props="{ contentClass: 'shadcn-select shadow-md', offset: 5 }"
            @update:model-value="updateLanguage"
        />
    </div>
</template>

<script>
import { useUserStore } from '@/stores/user';

export default {
    name: 'ChangeLanguage',
    data() {
        return {
            selectedLanguage: '',
            languages: [
                { value: 'en', label: 'English' },
                { value: 'de', label: 'Deutsch' },
            ],
        };
    },
    computed: {
        userStore() {
            return useUserStore();
        },
    },
    mounted() {
        this.selectedLanguage = localStorage.getItem('locale') || 'en';
    },
    methods: {
        updateLanguage() {
            this.userStore.set_locale(this.selectedLanguage);
        },
    },
};
</script>

<style scoped></style>
